// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"27269771","149":"5a222fec","453":"e240efb5","918":"f8674739","989":"f10ecb66"}[chunkId] + ".chunk.js";
};